import { useState, useEffect } from 'react';

export function useResponsiveLayout() {
  const [layoutMode, setLayoutMode] = useState('desktop');

  useEffect(() => {
    const applyResponsiveLayout = () => {
      const container = document.getElementById('cotizador-viajes') ||
                       document.querySelector('.quoterContainer')?.parentElement ||
                       document.body;

      const containerWidth = container.offsetWidth || window.innerWidth;

      let mode;
      if (containerWidth < 768) {
        mode = 'mobile';
      } else if (containerWidth < 1200) {
        mode = 'tablet';
      } else {
        mode = 'desktop';
      }

      setLayoutMode(mode);
    };

    const timer = setTimeout(applyResponsiveLayout, 100);

    let resizeObserver;
    if (typeof ResizeObserver !== 'undefined') {
      const container = document.getElementById('cotizador-viajes') || document.body;
      resizeObserver = new ResizeObserver(applyResponsiveLayout);
      resizeObserver.observe(container);
    } else {
      window.addEventListener('resize', applyResponsiveLayout);
    }

    return () => {
      clearTimeout(timer);
      if (resizeObserver) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', applyResponsiveLayout);
      }
    };
  }, []);

  return layoutMode;
}
